module.exports = __webpack_public_path__ + "img/logo-w.769d0341.png";